const state = () => ({
    _shown: false,
    _type: 'default',
});

const getters = {
    addFundsShown: (state) => state._shown,
};

const actions = {
    /**
     * Shows the add funds modal.
     *
     * @return {void}
     */
    showAddFunds() {
        this._setAddFundsShown();
    },

    /**
     * Hides the add funds modal.
     *
     * @return {void}
     */
    hideAddFunds() {
        this._setAddFundsHidden();
    },

    _setAddFundsShown() {
        this._shown = true;
    },

    _setAddFundsHidden() {
        this._shown = false;
    },
};

export default {
    state,
    getters,
    actions,
};
